// IMPORTANT: this file ships in the production bundle. The theme is built once and that single bundle
// is served to BOTH the WP Engine preview origin and indeed.com (Post-Press proxies the same
// HTML/assets), so this sample data is included in production even though it only renders on
// non-production preview hosts. Only ever put fabricated, non-sensitive sample data here — anything
// real or sensitive must come from Post-Press/server injection instead. See previewSampleData.ts.
const mockedData = {
  title: 'Job Title(ja_JP)',
  display: 'Displayed title(ja_JP)',
  modalData: {
    sourceName: 'Indeed data (JP)',
    sourceDate: 'June 2022',
    modalTitleSuffix: '採用に関する概要',
    sections: [
      {
        name: 'job_seekers',
        label: '求職者',
        amount: 601920,
        change_amount: -111508,
        date: 'July 2022',
        description: '求人をクリックした求職者の数',
        tooltip_info:
          'これは、選択した役職と勤務地の求人をクリックした、一意の追跡 Cookie によって識別される求職者の数です。',
      },
      {
        name: 'average_salary',
        label: '平均給与',
        unit: 'HOURLY',
        low: 10,
        high: 60,
        average: 28,
        tooltip_info:
          '\n' +
          '選択した役職と勤務地の平均給与 (該当する場合)。従業員、ユーザー、過去 36 か月までの Indeed 上の過去および現在の求人広告など、さまざまなソースからのデータを使用して計算されます。これらの数値は、一般的な比較のみを目的として提供されています。',
      },
      {
        name: 'employers',
        label: '雇用主',
        amount: 8754,
        description: '活動中の雇用主の総数',
        tooltip_info:
          '選択した役職と場所で求人情報を掲載し、クリックを受けた雇用主の総数',
      },
      {
        name: 'resumes',
        label: '履歴書',
        amount: 97233,
        change_amount: 1993,
        date: 'July 2022',
        description: 'Indeed で入手できる求職者の履歴書の数',
        tooltip_info:
          '\n' +
          '選択した検索で最後にリストされた職歴が含まれていた履歴書の数。 Indeed は、これらの求職者が現在積極的に就職活動を行っていることを保証するものではありません。',
      },
      {
        name: 'top_5_search_terms',
        label: 'クリック数上位 5 の検索語',
        tooltip_info:
          'これらは、[month]に、選択した役職と勤務地 (該当する場合) の求人のクリックにつながる最も人気のある検索語です。「募集中」や「求人」などの一般的な一般的なフレーズの一部がフィルターされている可能性があることに注意してください。このトップ10から外れました。',
        terms: ['会計', '会計士', '簿記係', 'スタッフ会計士', '買掛金勘定'],
        percentStrings: [
          '22.26',
          '11.11',
          '6.78',
          '5.55',
          '2.11',
        ],
      },
    ],
    ctas: [
      {
        text: 'さらに詳しい分析情報を見る',
        show: 'true',
        url: 'https://employers.indeed.com/o/hiring-insights?q=administrative+assistant&l=&country=US',
      },
      {
        text: '求人を投稿する',
        show: 'true',
        url: 'https://employers.indeed.com/p/post-job?hl=en_US&co=US',
      },
    ],
    localization: {
      locale: 'ja-JP',
      currency: 'JPY',
      sinceMonthFormat: '[month]以降',
      year: '年',
      month: '月',
      week: '週',
      day: '日',
      hour: '時',
      low: '低い',
      average: '平均',
      high: '高い',
    },
  },
};

export default mockedData;
